var EhmsStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService, SearchContainerHeight } from "./afla-module-strategy.service";
import _ from "underscore";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { ViewApplicationDetailsEhmsComponent } from "../../../application/view-application/modules/eh/view-application-details-ehms/view-application-details-ehms.component";
import { ViewApplicationApplicantEhmsComponent } from "../../../application/view-application/modules/eh/view-application-applicant-ehms/view-application-applicant-ehms.component";
import { ViewApplicationPremisesEhmsComponent } from "../../../application/view-application/modules/eh/view-application-premises-ehms/view-application-premises-ehms.component";
import { ViewApplicationInspectionsEhmsComponent } from "../../../application/view-application/modules/eh/view-application-inspections-ehms/view-application-inspections-ehms.component";
import { CreateApplicationDetailsEhmsComponent } from "../../../application/create-application/modules/eh/create-application-details-ehms/create-application-details-ehms.component";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { catchError, distinctUntilChanged, map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject, throwError } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiEhmsConstants } from "../../constants/api-constants/api-ehms.constants";
import { AlertType } from "../../models/alert";
import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { ActivatedRoute, Router } from "@angular/router";
import { RecipientSelectService } from "../../components/recipient-select/shared/service/recipient-select.service";
import { SearchOptionsConstants } from "../../../core/settings/components/search-options/search-options-constants";
import { ApiSearchOptionConstants } from "../../constants/api-constants/api-search-option.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import RecipientUtils from "../../utils/recipient-utils";
import { CreateApplicationApplicantEhmsComponent } from "../../../application/create-application/modules/eh/create-application-applicant-ehms/create-application-applicant-ehms.component";
import { CreateApplicationPremisesDetailsEhmsComponent } from "../../../application/create-application/modules/eh/create-application-premises-details-ehms/create-application-premises-details-ehms.component";
import { minLengthArray } from "../../classes/min-length-array-validator";
import { EsriDataTypeEnum } from "../../models/esri-data-type-enum";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { ModulePrefix } from "../../models/module-prefix.model";
// Not to be sorted!!!! ==> Already in correct sort order
// Please do not rename the enums ==> it will break the SearchOptions Field?Column Settings! Labels can be changed without any impact.
export var EhmsSearchOptions;
(function (EhmsSearchOptions) {
    EhmsSearchOptions["ReferenceNumber"] = "Reference Number";
    EhmsSearchOptions["MyApplications"] = "My Applications";
    EhmsSearchOptions["ApplicationsWithoutStartDate"] = "Applications Without Start Date";
    //  ApplicantInfo = "Applicant Information",
    EhmsSearchOptions["AppID"] = "Application ID";
    EhmsSearchOptions["UnassignedApplications"] = "Unassigned Applications";
    EhmsSearchOptions["JobID"] = "Job ID";
    // ApplicationStatus = "Application Status",
    // ApplicationTypes = "Application Types",
    // AssignedToUsers = "Assigned to",
    // CreatedDate = "Created Date",
    // CreatedDateRange = "Created Date Range",
    // DaysUntilExpired = "Days until Expired",
    // PercentageComplete = "Percentage Complete",
    // TimeoutStatus = "Timeout Status",
    // InspectorInfo = "Inspector Information",
    // PremisesType = "Premises Type",
    // PremisesName = "Premises Name"
})(EhmsSearchOptions || (EhmsSearchOptions = {}));
// TODO these columns will change depending on how columns have been configured. This is the default list
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["StartDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.ApplicationType, "applicationType"],
    [ApplicationHeadingEnum.StartDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Inspector"] = "Inspector";
    ApplicationSummaryColumnsEnum["PremiseName"] = "Premise Name";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["StartDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["ApplicationStatus"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.ApplicationType, "applicationType"],
    [ApplicationSummaryColumnsEnum.StartDate, "startDate"],
    [ApplicationSummaryColumnsEnum.ApplicationStatus, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const EhmsSearchQueryLookup = new Map([
    [EhmsSearchOptions.AppID, "appId"],
    [EhmsSearchOptions.ReferenceNumber, "referenceNumber"],
    [EhmsSearchOptions.JobID, "jobId"]
]);
export const EhmsAdditionalSearchOptions = [EhmsSearchOptions.MyApplications,
    EhmsSearchOptions.UnassignedApplications,
    // EhmsSearchOptions.AssignedToUsers
    EhmsSearchOptions.ApplicationsWithoutStartDate
];
export const EhmsDateSearchOptions = new Map([
// [EhmsSearchOptions.CreatedDate, 1],
// [EhmsSearchOptions.CreatedDateRange, 2],
]);
export const EhmsStatusSearchOptions = new Map([
// [EhmsSearchOptions.ApplicationStatus, ApplicationSearchConstants.STATUS],
// [EhmsSearchOptions.PercentageComplete, ApplicationSearchConstants.PERCENT_COMPLETE],
// [EhmsSearchOptions.DaysUntilExpired, ApplicationSearchConstants.DAYS_UNTIL_EXPIRED],
// [EhmsSearchOptions.TimeoutStatus, ApplicationSearchConstants.TIMEOUT_STATUS],
]);
export const EhmsSearchOptionClientHeight = new Map([
    [EhmsSearchOptions.ReferenceNumber, SearchContainerHeight.Simple],
    [EhmsSearchOptions.MyApplications, SearchContainerHeight.Simple],
    [EhmsSearchOptions.AppID, SearchContainerHeight.Simple],
    // [EhmsSearchOptions.ApplicationStatus, SearchContainerHeight.SingleLine],
    // [EhmsSearchOptions.ApplicationTypes, SearchContainerHeight.SingleLine],
    // [EhmsSearchOptions.PercentageComplete, SearchContainerHeight.SingleLine],
    // [EhmsSearchOptions.DaysUntilExpired, SearchContainerHeight.SingleLine],
    // [EhmsSearchOptions.TimeoutStatus, SearchContainerHeight.SingleLine],
    // [EhmsSearchOptions.CreatedDate, SearchContainerHeight.SingleLine],
    // [EhmsSearchOptions.AssignedToUsers, SearchContainerHeight.SingleLine],
    // [EhmsSearchOptions.CreatedDateRange, SearchContainerHeight.SingleLine],
    // [EhmsSearchOptions.ApplicantInfo, SearchContainerHeight.Extended],
    // [EhmsSearchOptions.InspectorInfo, SearchContainerHeight.Extended],
    // [EhmsSearchOptions.PremisesType, SearchContainerHeight.SingleLine],
    // [EhmsSearchOptions.PremisesName, SearchContainerHeight.SingleLine]
]);
export const EhmsRequiredMapFields = [{
        mapName: "Property",
        fields: [
            { name: "OBJECTID", type: EsriDataTypeEnum.oid },
            { name: "SgCode", type: EsriDataTypeEnum.string },
            { name: "ErfNo", type: EsriDataTypeEnum.string },
            { name: "FarmNo", type: EsriDataTypeEnum.string },
            { name: "PtnNum", type: EsriDataTypeEnum.string },
            { name: "Allotment", type: EsriDataTypeEnum.string },
            { name: "PropertyDescription", type: EsriDataTypeEnum.string },
            { name: "Address", type: EsriDataTypeEnum.string },
            { name: "TotalValue", type: EsriDataTypeEnum.integer },
            { name: "HasGeometry", type: EsriDataTypeEnum.integer },
            { name: "ErfSize", type: EsriDataTypeEnum.integer },
            { name: "TitleDeed", type: EsriDataTypeEnum.string },
            { name: "SectionalTitleSchemeID", type: EsriDataTypeEnum.string },
            { name: "Type", type: EsriDataTypeEnum.string },
            { name: "LegalStatus", type: EsriDataTypeEnum.string },
            { name: "FloorNo", type: EsriDataTypeEnum.string },
            { name: "FloorName", type: EsriDataTypeEnum.string },
            { name: "SgDiagramNo", type: EsriDataTypeEnum.string },
            { name: "UnitNumber", type: EsriDataTypeEnum.integer },
            { name: "Registered", type: EsriDataTypeEnum.smallInteger },
            { name: "SgCodeExternal", type: EsriDataTypeEnum.string },
            { name: "PremiseID", type: EsriDataTypeEnum.string },
            { name: "AccountNo", type: EsriDataTypeEnum.string },
            { name: "ZoningCategory", type: EsriDataTypeEnum.string },
            { name: "Shape", type: EsriDataTypeEnum.geometry },
            { name: "Shape_Area", type: EsriDataTypeEnum.double },
            { name: "Shape_Length", type: EsriDataTypeEnum.double }
        ]
    }];
// IMPORTANT: these values much match the DB table names and the Property names used by oData entity for TownPlanning
export var EhmsSearchOptionTableListEnum;
(function (EhmsSearchOptionTableListEnum) {
    EhmsSearchOptionTableListEnum["Application"] = "EH_APPLICATION|Application";
    EhmsSearchOptionTableListEnum["Inspections"] = "EH_INSPECTION|Inspections";
    EhmsSearchOptionTableListEnum["Status"] = "AFLA_APPLICATIONSTATUS|Status";
    EhmsSearchOptionTableListEnum["Applicant"] = "AFLA_Recipient|Applicant";
})(EhmsSearchOptionTableListEnum || (EhmsSearchOptionTableListEnum = {}));
export const EHExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_EH;
export const TPTableNameListForSearchOptions = EhmsSearchOptionTableListEnum.Application
    + "," + EhmsSearchOptionTableListEnum.Status
    + "," + EhmsSearchOptionTableListEnum.Applicant;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Details"] = "Details";
    CreateApplicationMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationMenuHeadings["Premises"] = "Premises";
    // Assessment = "Assessment",
    // Attachments = "Attachments",
    // Checklist = "Checklist",
    CreateApplicationMenuHeadings["Comments"] = "Comments";
    CreateApplicationMenuHeadings["RequiredDocumentsChecklist"] = "Required documents checklist";
    // Communication = "Communication",
    // Conditions = "Conditions",
    // TODO: Add Applicant & notes
    // ApplicantAgent = "Applicant",       //we are not using ApplicationAgent for EH
    CreateApplicationMenuHeadings["Notes"] = "Notes";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Details"] = "Details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    // Location = "Location",
    ViewApplicationMenuHeadings["Premises"] = "Premises";
    ViewApplicationMenuHeadings["Inspections"] = "Inspections";
    ViewApplicationMenuHeadings["Attachments"] = "Attachments";
    ViewApplicationMenuHeadings["History"] = "History";
    ViewApplicationMenuHeadings["RelatedApplicationSearch"] = "Related applications";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["ScheduledReminders"] = "Scheduled Reminders";
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["StepManagement"] = "Step management";
    ViewApplicationMenuHeadings["Timeouts"] = "Timeouts";
    ViewApplicationMenuHeadings["Team"] = "Team";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export var SettingsMenuHeadings;
(function (SettingsMenuHeadings) {
    SettingsMenuHeadings["AvailableSurvey123s"] = "Available survey123s";
    SettingsMenuHeadings["Lookups"] = "Lookups";
    SettingsMenuHeadings["MapConfig"] = "Map services";
    SettingsMenuHeadings["NonWorkingDays"] = "Non-working days";
    SettingsMenuHeadings["AttachmentTypes"] = "Attachment types";
    SettingsMenuHeadings["Recipients"] = "Recipients";
    SettingsMenuHeadings["RecipientGroups"] = "Recipient groups";
    SettingsMenuHeadings["Reports"] = "Reports";
    SettingsMenuHeadings["StepMetaData"] = "Step metadata";
    SettingsMenuHeadings["Tariffs"] = "Tariffs";
    SettingsMenuHeadings["Templates"] = "Templates";
    SettingsMenuHeadings["NotificationTemplates"] = "Notification templates";
    SettingsMenuHeadings["ModuleRoles"] = "Module roles";
    SettingsMenuHeadings["AFLAPortalDocuments"] = "Afla portal documents";
    SettingsMenuHeadings["AFLAPortalUpdateOwners"] = "Afla portal update owners";
    SettingsMenuHeadings["SearchOptions"] = "Search options";
    SettingsMenuHeadings["SearchSettings"] = "Search settings";
    SettingsMenuHeadings["BackupRestore"] = "Backup and restore";
    SettingsMenuHeadings["ArcGISItems"] = "ArcGIS items";
    SettingsMenuHeadings["AFLAPortalMessagesAndPages"] = "AFLA portal messages and pages";
    SettingsMenuHeadings["LinkInsectionSurveys"] = "Link inspection surveys";
    SettingsMenuHeadings["InvoiceTemplates"] = "Invoice templates";
    SettingsMenuHeadings["Stamps"] = "Stamps";
    SettingsMenuHeadings["ApplicationWorkflowUpgrade"] = "Application workflow upgrade";
})(SettingsMenuHeadings || (SettingsMenuHeadings = {}));
let EhmsStrategyService = class EhmsStrategyService extends AflaModuleStrategyService {
    static { EhmsStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    http;
    appController;
    router;
    recipientSelectService;
    route;
    buildingUseSearchOptions;
    overdueApplicationExpandFields = "status, applicant";
    showApplicantAgentForModule = true;
    requiredMapFields;
    createApplicationMenuHeadings;
    overrideMapDefault = {};
    viewApplicationComponentLookup;
    name = ModuleConfig.EnvironmentalHealth;
    modulePrefix = ModulePrefix.EnvironmentalHealth;
    searchQueryLookup;
    defaultSearchColumns;
    searchOptions;
    applicationEndpoint;
    premisesEndpoint;
    extendedSimpleSearchOptions;
    dateSearchOptions;
    RangeSearchOptions;
    statusSearchOptions;
    groupSearchOptions;
    clientHeightMap;
    createApplicationComponentLookup;
    advancedSearchComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    // column headers are dynamic
    applicationTableColumnMap = new BehaviorSubject(null);
    applicationTableColumnMapObservable = this.applicationTableColumnMap.asObservable();
    applicationServiceUrl = ApiEhmsConstants.URL;
    premisesServiceUrl = ApiEhmsConstants.PREMISES_URL;
    form;
    lookups = new Map();
    userId;
    moduleUsers;
    expandListForApplicationSearch = EHExpandListForApplicationSearch;
    expandListForApplicationSearchFullList = EHExpandListForApplicationSearch;
    searchOptionTableNameList = TPTableNameListForSearchOptions;
    customApplicationTableColumnMap = null;
    selectedSearchOptionLookup;
    searchOptionsWithCustomColumns = [];
    searchOptionsFieldList;
    searchOptionsMap;
    isPrevSavedSearch = false;
    aflaPortalConfigurableMessages = [
        "Welcome help",
        "Application help",
        "Applicant help",
        "Required documentation help",
        "Notes help",
        "Welcome page",
        "Create application status page",
        "View application status page",
        "Communication help"
    ];
    setApplicantAndApplicantAgentAction = ApiEhmsConstants.FUNCTION_SET_APPLICANT;
    settingsMenuHeadings;
    settingsComponentLookup;
    propertiesPageHeading = "Premises";
    moduleRequiredMaps;
    stampOptions = [];
    previousApplication = null;
    statusColumn = "status/ workflowSection";
    getPremisesQuerySubscription;
    createApplicationEhmsSubscription;
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, requestStatusService, http, appController, router, recipientSelectService, route) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.recipientSelectService = recipientSelectService;
        this.route = route;
        this.initForm();
        this.applicationEndpoint = ApiApplicationSearchConstants.EHMS_ENDPOINT;
        this.premisesEndpoint = ApiEhmsConstants.PREMISES_URL;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        this.settingsMenuHeadings = SettingsMenuHeadings;
        this.moduleRequiredMaps = ["Property"];
        this.requiredMapFields = EhmsRequiredMapFields;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on an child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        const column = filter ? filter : ApplicationSearchConstants.DEFAULT_SEARCH;
        return `contains(tolower(cast(${column.trim()},'Edm.String')),'${text.trim().toLowerCase()}') and eLodgementComplete eq true`;
    }
    static buildExpand(params, top) {
        params = params.set(ODataAction.Expand, EHExpandListForApplicationSearch);
        params = params.set(ODataAction.Top, top);
        params = params.set(ODataAction.OrderBy, "startDate ne null desc, startDate desc, appId desc");
        return params;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    buildListFilter(list, column) {
        const params = EhmsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getStatusForModule(moduleID, statusField) {
        return this.applicationSearchService.getStatusForModule(moduleID, statusField);
    }
    getUsersForModule(moduleID) {
        return this.applicationSearchService.getUsersForModule(moduleID);
    }
    initializeSearchQueryLookup() {
        this.searchQueryLookup = EhmsSearchQueryLookup;
    }
    initializeAdditionalSearchLookup() {
        this.extendedSimpleSearchOptions = EhmsAdditionalSearchOptions;
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initializeSearchOptionsLookup() {
        this.searchOptions = new Array();
        this.searchOptions.push(..._.values(EhmsSearchOptions));
        // this is used for the SearchOptions settings
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(EhmsSearchOptions)) {
            this.searchOptionsMap.set(key, value);
        }
        // default column list if search option types does not have a default
        this.defaultSearchColumns = applicationHeadingLookup;
    }
    initializeDateSearchOptions() {
        this.dateSearchOptions = EhmsDateSearchOptions;
    }
    initializeStatusSearchOptions() {
        this.statusSearchOptions = EhmsStatusSearchOptions;
        this.clientHeightMap = EhmsSearchOptionClientHeight;
    }
    initializeGroupSearchOptions = () => {
    };
    getFieldListForSearchOptions(moduleId) {
        const params = {
            $filter: EhmsStrategyService_1.buildModuleIDFilter(moduleId),
            $expand: SearchOptionsConstants.SEARCH_OPTIONS_EXPAND,
            $orderby: SearchOptionsConstants.SEARCH_OPTIONS_COLUMNS_ORDERBY
        };
        const url = `${ApiSearchOptionConstants.URL}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            this.searchOptionsWithCustomColumns = [];
            this.searchOptionsFieldList = response.value;
            this.searchOptionsFieldList.forEach((option) => {
                const searchOptionLookup = this.getSearchOptionLookup(option.searchOption);
                // @ts-ignore
                if (this.searchOptionsWithCustomColumns.indexOf(searchOptionLookup) < 0) { // @ts-ignore
                    this.searchOptionsWithCustomColumns.push(searchOptionLookup);
                }
            });
            return response.value;
        }));
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: EhmsStrategyService_1.getRecipientName(application.applicant),
            agent: null, // don't need this here but we have to have it as a default for now
            applicationType: application.applicationType,
            startDate: application.createdDate !== null
                ? this.saShortDatePipe.transform(application.startDate)
                : "",
            // TODO: we have relabelled all instances of "Phase" to "Application status"
            //  - do we need to do the same for the property name "phase" => "applicationStatus" for consistency?
            //  - don't forget to apply to all module services!!
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null
                ? this.saShortDatePipe.transform(application.lastEditedDate)
                : "",
            moduleId: application.moduleId,
            createdFromMobileDevice: false
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getApplicationFieldValue(application, appGroup, fieldName) {
        let fieldValue;
        for (const [key, value] of Object.entries(application)) {
            if (!fieldValue && appGroup.toLowerCase() === "application") {
                if (key.toLowerCase() === fieldName.toLowerCase()) {
                    fieldValue = value;
                    break;
                }
            }
            else {
                if (!fieldValue
                    && key.toLowerCase() === appGroup.toLowerCase()) {
                    // some applications may have null lower order properties e.g. Status
                    if (value) {
                        const group = value[0] ? value[0] : value;
                        for (const [groupKey, groupValue] of Object.entries(group)) {
                            switch (appGroup.toLowerCase()) {
                                case "applicant":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = groupValue;
                                        break;
                                    }
                                    break;
                                case "status":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        switch (fieldName.toLowerCase()) {
                                            case "assignedto":
                                            case "createdby":
                                                // these fields will be handled in the user section below
                                                break;
                                            default:
                                                fieldValue = groupValue;
                                                break;
                                        }
                                        break;
                                    }
                                    break;
                                // the following properties can be multiple values - we cannot use ObjectUtils.getCommaSeparatedValuesFromListForKey because it is case sensitive
                                // case "properties":
                                //   if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                //     fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                //   }
                                //   break;
                            }
                        }
                    }
                }
                if (fieldValue)
                    break;
            }
        }
        // // Owner is the only 3rd level table that is referenced
        // const propertyDetails = [ApplicationSearchConstants.ZONINGS, ApplicationSearchConstants.OWNERS];
        // if (!fieldValue && propertyDetails.indexOf(appGroup.toLowerCase()) > -1) {
        //   if (application.properties.length > 0) {
        //     application.properties.forEach((property: ITpProperty) => {
        //       for (const [propkey, propVal] of Object.entries(property)) {
        //         if (propkey.toLowerCase() === appGroup.toLowerCase()
        //           || (propkey.toLowerCase().endsWith(ApplicationSearchConstants.ZONINGS) && appGroup.toLowerCase().endsWith(ApplicationSearchConstants.ZONINGS))) {
        //           propVal.forEach((value) => {
        //             for (const [groupKey, groupValue] of Object.entries(value)) {
        //               if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
        //                 fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
        //               }
        //             }
        //           })
        //         }
        //       }
        //     })
        //   }
        // }
        if (!fieldValue)
            fieldValue = "";
        if (fieldName.toLowerCase().endsWith("date") || fieldName.toLowerCase().startsWith("date")) {
            fieldValue = fieldValue ? this.saShortDatePipe.transform(fieldValue) : "";
        }
        else {
            switch (fieldName.toLowerCase()) {
                case "lasteditedby":
                    fieldValue = this.getUserName(application.lastEditedUser);
                    break;
                case "createdby":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.createdBy) : "";
                    break;
                case "assignedto":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.assignedTo) : "";
                    break;
                case "createduserid":
                    fieldValue = this.getUserName(application.createdSystemUser);
                    break;
            }
        }
        return fieldValue;
    }
    customColumnSearchModel(application, columnList, isPrevSavedSearch = false) {
        // need to reset the column map if the search options customised columns have been updated
        // need to reset the column map if the search options customised columns have been updated
        if ((this.customApplicationTableColumnMap.size !== 0 && columnList.length !== this.customApplicationTableColumnMap.size)
            || isPrevSavedSearch) {
            this.customApplicationTableColumnMap.clear();
            this.isPrevSavedSearch = false;
        }
        let resetHeadings = this.customApplicationTableColumnMap.size === 0;
        const appDetails = {};
        if (columnList.length > 0) {
            columnList.forEach((column) => {
                const fieldAlias = column.moduleField.fieldAlias;
                const fieldName = column.moduleField.fieldName;
                const tableLookup = this.getSearchOptionLookup(`${column.moduleField.tableAlias}`);
                const appGroup = this.getApplicationTableProperty(`${column.moduleField.tableName}|${tableLookup}`);
                const appProperty = `${appGroup.toLowerCase()}${fieldName.toLowerCase()}`;
                appDetails[appProperty] = this.getApplicationFieldValue(application, tableLookup, fieldName);
                if (resetHeadings)
                    this.customApplicationTableColumnMap.set(fieldAlias, appProperty);
            });
            // standard fields to add in case the user did not add them
            // @ts-ignore
            appDetails.id = application.id;
            // @ts-ignore
            appDetails.moduleId = application.moduleId;
            // @ts-ignore
            appDetails.jobId = application.jobId;
            // @ts-ignore
            appDetails.appId = application.appId;
            // only set the headings once for the search
            if (resetHeadings) {
                this.changeAppTableColumnMap(this.customApplicationTableColumnMap);
                resetHeadings = false;
            }
            return appDetails;
        }
        else
            return this.defaultSearchModel(application);
    }
    getApplicationTableProperty(tableName) {
        let property = "";
        for (const [tableKey, tableValue] of Object.entries(EhmsSearchOptionTableListEnum)) {
            if (tableValue.toLowerCase() === tableName.toLowerCase()) {
                // @ts-ignore
                property = tableKey;
                break;
            }
        }
        return property;
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getCustomApplicationSearchModel(searchOptionLookup) {
        // identify columnList for specific search option
        return this.applicationSearchService.getSearchOptionColumnList(this, searchOptionLookup);
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        if (application) {
            return this.defaultSearchModel(application);
        }
    }
    initializeSettingsComponents() {
        this.settingsComponentLookup = new Map([]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [
                ViewApplicationMenuHeadings.Details,
                ViewApplicationDetailsEhmsComponent,
            ], [
                ViewApplicationMenuHeadings.Applicant,
                ViewApplicationApplicantEhmsComponent,
            ],
            [
                ViewApplicationMenuHeadings.Premises,
                ViewApplicationPremisesEhmsComponent,
            ],
            // [
            //   ViewApplicationMenuHeadings.Location,
            //   ViewApplicationLocationEhmsComponent,
            // ],
            [
                ViewApplicationMenuHeadings.Inspections,
                ViewApplicationInspectionsEhmsComponent,
            ],
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationMenuHeadings.Details,
                CreateApplicationDetailsEhmsComponent,
            ],
            [
                CreateApplicationMenuHeadings.Applicant,
                CreateApplicationApplicantEhmsComponent,
            ],
            [
                CreateApplicationMenuHeadings.Premises,
                CreateApplicationPremisesDetailsEhmsComponent,
            ]
        ]);
    }
    initializeAdvancedApplicationSearchComponents() {
        this.advancedSearchComponentLookup = new Map([
        // [
        //   EhmsSearchOptions.AssignedToUsers,
        //   SearchAssignedToComponent,
        // ],
        // [
        //   EhmsSearchOptions.CreatedDate,
        //   SearchCreatedDateComponent,
        // ],
        // [
        //   EhmsSearchOptions.CreatedDateRange,
        //   SearchCreatedDateComponent,
        // ],
        // [
        //   EhmsSearchOptions.StartDate,
        //   SearchStartDateComponent,
        // ],
        // [
        //   EhmsSearchOptions.StartDateRange,
        //   SearchStartDateComponent,
        // ],
        // [
        //   EhmsSearchOptions.ApplicantInfo,
        //   SearchApplicantInfoComponent,
        // ],
        // [
        //   EhmsSearchOptions.PercentageComplete,
        //   SearchStatusComponent,
        // ],
        // [
        //   EhmsSearchOptions.ApplicationStatus,
        //   SearchStatusComponent,
        // ],
        // [
        //   EhmsSearchOptions.TimeoutStatus,
        //   SearchStatusComponent,
        // ],
        // [
        //   EhmsSearchOptions.DaysUntilExpired,
        //   SearchStatusComponent,
        // ],
        // //TODO:: take this out
        // [
        //   EhmsSearchOptions.ApplicationTypes,
        //   SearchApplicationTypeTpamsComponent,
        // ],
        // [
        //   EhmsSearchOptions.InspectorInfo,
        //   SearchInspectorInfoEhComponent
        // ],
        // [
        //   EhmsSearchOptions.PremisesName,
        //   SearchPremisesNameEhComponent
        // ],
        // [
        //   EhmsSearchOptions.PremisesType,
        //   SearchPremisesTypeEhComponent
        // ]
        ]);
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    initializeApplicationTableColumnMap() {
        this.changeAppTableColumnMap(this.customApplicationTableColumnMap
            ? this.customApplicationTableColumnMap : applicationHeadingLookup);
    }
    changeAppTableColumnMap(tableColumnMap) {
        this.applicationTableColumnMap.next(tableColumnMap);
    }
    doSearchApplicationsByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByResponsiblePerson(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchUnassignedApplications(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUnassignedApplication(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsWithoutStartDate(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsWithoutStartDate(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "appId", true, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doApplicationSearch(search, moduleID, pageHeading, withDefaultColumns) {
        const column = this.getEntityColumn(search.column);
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsUsingSimpleSearch(search.text, column, this, moduleID, withDefaultColumns)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationsQuery(params) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    getApplicationsQueryExtended(params, extendedEndPoint) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint, extendedEndPoint), { params });
    }
    getPremisesQuery(params) {
        return this.http.get(this.premisesEndpoint, { params });
    }
    getPremisesOwners(id) {
        const params = {
            // $select: "properties",
            $expand: "premises($expand=owners)",
            $filter: `id eq ${id} and moduleId eq ${+this.appControllerService.selectedModuleID}`
        };
        this.getPremisesQuerySubscription = this.getPremisesQuery(params).subscribe({
            next: (response) => {
                const properties = response.value[0]?.properties;
                return response;
            },
            error: (error) => {
                this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                this.requestStatusService.removeBusySpinner("continueToNextStep");
            }
        });
    }
    getApplicationsSearchRequestWithAdditionalFilters(text, filter, moduleID) {
        let params = EhmsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AflaModuleStrategyService.buildModuleIDFilter(moduleID), EhmsStrategyService_1.buildColumnFilter(text, filter));
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = EhmsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, EhmsStrategyService_1.buildModuleIDFilter(moduleID), EhmsStrategyService_1.showCompleteApplications());
        return this.getApplicationsQuery(params);
    }
    buildDashboardApplicationsSearch(moduleID, dashboardFilter) {
        let params = EhmsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.applicationSearchService.dashboardSearch(params, dashboardFilter, moduleID);
        return this.getApplicationsQuery(params);
    }
    createApplication() {
        this.requestStatusService.showBusySpinner("CreateEHMSApplication");
        const application = this.buildApplication();
        // const jsonString = JSON.stringify(application);
        this.createApplicationEhmsSubscription =
            this.postApplicationService(application)
                .subscribe({
                next: (savedApplication) => {
                    this.appController.showMessage(EhmsStrategyService_1.successMessage(savedApplication.jobId), AlertType.Success);
                    this.resetForm();
                    this.requestStatusService.removeBusySpinner("CreateEHMSApplication");
                    this.router.navigate([
                        AppRoutingConstants.ROUTE_SEPERATOR + ApplicationsRoutingConstants.REFRESH_ROUTE,
                        {
                            jobId: savedApplication.jobId,
                            moduleId: this.appController.selectedModuleID,
                            type: ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE
                        }
                    ]);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("CreateEHMSApplication");
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
                }
            });
    }
    resetForm() {
        this.form.reset();
        // (this.form.get("noteForm").get("notes") as FormArray).clear();
    }
    postApplicationService(params) {
        return this.http.post(ApiEhmsConstants.URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        // return "status, applicant, applicant($expand=groups), lastEditedUser";
        return "status, applicant, lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_EH_APPLICATIONS_BY_USER;
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_CREATED_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_EH_APPLICATIONS_CREATED_BY_USER;
        }
    }
    getSearchResponsiblePersonUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON:
                return ApiApplicationSearchConstants.FUNCTION_GET_EH_APPLICATIONS_BY_RESPONSIBLEPERSON;
        }
    }
    generateInvoiceReportService(applicationId, invoiceID, canDownloadInPortal = false) {
        const params = {
            invoiceId: invoiceID,
            canDownloadInPortal
        };
        return this.http.get(`${ApiEhmsConstants.URL}/${applicationId}/${ApiEhmsConstants.FUNCTION_GET_GENERATE_INVOICE}`, { responseType: "blob", params });
    }
    getRequiredDocumentsChecklist(applicationId, jobId) {
        const params = {
            $filter: jobId
        };
        return this.http.get(`${ApiEhmsConstants.URL}/${applicationId}/${ApiEhmsConstants.FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getExternalLinks(moduleId, jobId, category) {
        var params = {
            jobId: jobId,
            category: category
        };
        return this.http.get(`${ApiEhmsConstants.URL}/${moduleId}/${ApiEhmsConstants.FUNCTION_GET_EXTERNAL_LINKS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    initForm() {
        // this.tableHeadingsIsChangedObservable = this.tableHeadingsIsChanged.asObservable()
        this.form = new FormGroup({
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null),
                applicantAgentRecipient: new FormControl(null),
                copyApplicantDetails: new FormControl(null),
                markApplicantDetailsAsNotApplicable: new FormControl(null),
                markApplicantAgentAsNotApplicable: new FormControl(null)
            }),
            noteForm: new FormGroup({
                newNote: new FormControl(null),
                notes: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                referenceNumber: new FormControl(null),
                startDate: new FormControl(null, [Validators.required]),
                applicationType: new FormControl(null, [Validators.required]),
                communicationMethod: new FormControl(null, [Validators.required])
            }),
            premisesForm: new FormGroup({
                premises: new FormArray([], [minLengthArray(1), Validators.required]),
            }),
        });
    }
    getEntityColumn(searchColumn) {
        switch (searchColumn) {
            case SharedConstants.SEARCH_BY_DEFAULT:
                return SharedConstants.SEARCH_BY_DEFAULT;
            case SharedConstants.DASHBOARD_FILTERS.LatestApplications:
                return SharedConstants.DASHBOARD_FILTERS.LatestApplications;
            case SharedConstants.DASHBOARD_FILTERS.OverdueApplications:
                return SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
            case SharedConstants.DASHBOARD_FILTERS.OpenApplications:
                return SharedConstants.DASHBOARD_FILTERS.OpenApplications;
            case SharedConstants.DASHBOARD_FILTERS.ClosedApplications:
                return SharedConstants.DASHBOARD_FILTERS.ClosedApplications;
            case SharedConstants.DASHBOARD_FILTERS.TotalApplications:
                return SharedConstants.DASHBOARD_FILTERS.TotalApplications;
            case SharedConstants.DASHBOARD_FILTERS.ApplicationStatus:
                return this.statusColumn;
            default:
                return this.searchQueryLookup.get(searchColumn);
        }
    }
    buildApplication() {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeRecipientProperties(applicantFormValue);
        const application = {
            applicationStartDate: this.form.get("detailsForm").get("startDate").value,
            communicationMethod: this.form.get("detailsForm").get("communicationMethod").value,
            decision: "",
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            applicant,
            applicationType: this.form.get("detailsForm").get("applicationType").value,
            notes: [],
            premises: [],
            eLodgementStep: 0,
            eLodgementComplete: true,
            createdFromMobileDevice: false
        };
        const notesArray = this.form.get("noteForm").get("notes");
        notesArray.controls.forEach((item) => {
            const note = {
                note: item.get("note").value,
            };
            application.notes.push(note);
        });
        const premisesArray = this.form.get("premisesForm").get("premises");
        premisesArray.controls.forEach((item) => {
            let owners = [];
            if (item.get("owners").value && item.get("owners").value.recipients) {
                owners = item.get("owners").value.recipients;
                owners.forEach((owner) => {
                    owner = RecipientUtils.removeRecipientProperties(owner);
                });
            }
            // const owners: IRecipient[] = item.get("owners").value.recipients? item.get("owners").value.recipients : [];
            let contacts = [];
            if (item.get("contacts").value && item.get("contacts").value.recipients) {
                contacts = item.get("contacts").value.recipients;
                contacts.forEach((contact) => {
                    contact = RecipientUtils.removeRecipientProperties(contact);
                });
            }
            const geometry = item.get("geometry").value;
            const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            const premises = {
                id: item.get("id").value,
                address: item.get("address").value,
                cellphone: item.get("cellphone").value,
                email: item.get("email").value,
                fax: item.get("fax").value,
                moduleId: item.get("moduleId").value,
                name: item.get("name").value,
                owners,
                contacts,
                shape: geometryJSON,
                wkid: 102100,
                postalAddress: item.get("postalAddress").value,
                premiseType: item.get("premiseType").value,
                telephone: item.get("telephone").value,
            };
            application.premises.push(premises);
        });
        return application;
    }
    getApplicationGeometries(jobID, moduleID) {
        const params = {
            $select: "shape, properties",
            $expand: "properties",
            $filter: `jobId eq ${+jobID} and moduleId eq ${+moduleID}`
        };
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    initializeBuildingUseSearchOptions() {
    }
    doSearchApplicationsByCreatedByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsCreatedByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiEhmsConstants.URL}/${jobId}/${ApiEhmsConstants.FUNCTION_APPLICATION_TYPES}`;
        return this.http.get(url, { params });
    }
    saveDraftApplication() {
    }
    getDraftApplication() {
        return null;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router },
        { type: RecipientSelectService },
        { type: ActivatedRoute }
    ];
};
EhmsStrategyService = EhmsStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsub()
], EhmsStrategyService);
export { EhmsStrategyService };
